'use client';

type ScoreboardFooterProps = {
	type: string;
	title: string;
	value: string;
};

export const ScoreboardFooter = ({ type, title, value }: ScoreboardFooterProps) => {
	switch (type) {
		case 'left':
			return (
				<div className="scoreboard__text-group">
					<span className="scoreboard__text scoreboard__text--accent">{value}</span>
					<span className="scoreboard__text">{title}</span>
				</div>
			);
		case 'right':
			return (
				<div className="scoreboard__text-group">
					<span className="scoreboard__text">{title}</span>
					<span className="scoreboard__text scoreboard__text--accent">{value}</span>
				</div>
			);
		case 'mutil':
			return (
				<span className={`scoreboard__text ${value === '1' ? 'scoreboard__text--base' : ''}`}>{title}</span>
			);
	}
};


